const transformImgLink = link => {
  // return 'https://images.headlines.pw' + link
  return link
}

export default transformImgLink



// WEBPACK FOOTER //
// ./src/assets/utils/transformImgLink.js